import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { WebsiteLayoutBodyWrapper } from './ui/website-layout-body-wrapper'

export interface CommonWebsiteLayoutBodyProps {
  header: React.ReactNode
  content?: React.ReactNode
  footer: React.ReactNode
  background: string | undefined
  backgroundImage: string
}

export const CommonWebsiteLayoutBody = ({
  header,
  content,
  footer,
  background,
  backgroundImage,
}: CommonWebsiteLayoutBodyProps) => {
  const { t } = useTypedTranslation()

  return (
    <WebsiteLayoutBodyWrapper
      background={background}
      backgroundImage={backgroundImage}
    >
      {header}
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {content ?? (
          <div
            style={{
              minHeight: '640px',
              width: '100%',
              backgroundColor: 'fff',
            }}
          >
            {t('components.website_layout_body.content_placeholder')}
          </div>
        )}
      </main>
      {footer}
    </WebsiteLayoutBodyWrapper>
  )
}
